var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"recommendPage"},[(_vm.infoList.length>0)?_c('swiper',{ref:"mySwiper",attrs:{"options":_vm.swiperOption}},[_vm._l((_vm.infoList),function(it,i){return _c('swiper-slide',{key:i},[_c('img',{attrs:{"src":it.resource}})])}),_c('div',{staticClass:"swiper-pagination",attrs:{"slot":"pagination"},slot:"pagination"})],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }